import axios from "axios";
import { Agent } from "../interfaces/agent.interface";

const clean = (str) => str !=  null ? str.replace(/\s+/g, ' ') : "";
const toTitleCase = (str: string): string => {
  return clean(str).toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
}

class AgentsApi
 {

  getAgents(agentsParams): Promise<Agent[]> {
    const apiUrl = "/api/v1/users/agents";

    return axios.get(apiUrl,{ 
      params: agentsParams
    })
    .then(response => {
      const agents = response.data.agents.map(agentData => {
        const agent:Agent = {
          id: agentData.id,
          name: agentData.full_name,
          email: agentData.email,
          image: agentData.image,
          phone: agentData.phone,
          whatsapp: agentData.whatsapp_no,
          address: agentData.address,
          city: toTitleCase(agentData.city),
          state: toTitleCase(agentData.state),
          zone: agentData.zone
        }
        return agent;
      })
      return Promise.resolve(agents);
    });
  }

}

export default AgentsApi
;